import axios from "./axios";
export default {
  async getAllTasksStatuses() {
    const statuses = await axios.getData(
      "/auth/get-all-tasks-statuses",
      localStorage.getItem("token")
    );
    return statuses;
  },
  async getAllTasks() {
    const tasks = await axios.getData(
      "/auth/get-all-tasks",
      localStorage.getItem("token")
    );
    return tasks;
  },
  async saveOrEditTasks(
    clientIDs,
    title,
    statusID,
    email,
    id,
    start,
    end,
    staffID,
    rateID,
    rates,
    hours,
    caseID
  ) {
    const tasks = await axios.postDataWithToken(
      "/auth/save-or-edit-tasks",
      {
        clientIDs,
        title,
        statusID,
        email,
        id,
        start,
        end,
        staffID,
        rateID,
        rates,
        hours,
        caseID,
      },
      localStorage.getItem("token")
    );
    return tasks;
  },
};
